module.exports = {
  colors: {
    'cyber-gray': '#ebebeb',
    'dark-gray': '#696F7A',
    'darker-gray': '#383B40',
    'darkest-gray': '#171D23',
    'code-blue': '#171D23',
    'flashbang-white': '#FFFFFF',
    'new-black': '#110B0B',
    black: '#000000',
    'emerald-green': '#4FE11B',
    'matrix-green': '#6FC651',
    'lighter-black': '#141417',
    'pixel-blue': '#54B8F5',
    'primary-purple': '#7000FF',
    'punk-red': '#E85A43',
    'dark-red': '#b70202',
    smoke: '#B3BBCA',
    'light-smoke': '#D4DEEF',
    'warning-yellow': '#F5D946',
    transparent: 'transparent',
  },
  boxShadow: {
    'outline-white': '0px 0px 0px 1px rgba(255, 255, 255, 1)',
    'outline-new-black': '0px 0px 0px 1px #110B0B',
    md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
  },
  screens: {
    xxs: '375px',
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },
  containers: {
    xs: '20rem',
    sm: '24rem',
    md: '28rem',
    lg: '32rem',
    xl: '36rem',
    '2xl': '42rem',
    '3xl': '48rem',
    '4xl': '56rem',
    '5xl': '64rem',
    '6xl': '72rem',
    '7xl': '80rem',
  },
  animation: {
    'spin-loading-icon': 'loadingIconSpin 3s infinite',
    'spin-countdown': 'spinExtreme 5s cubic-bezier(1, 0.01, 0.945, 0.88)',
    spin: 'spin 1s linear infinite',
    pulse: 'pulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite',
    'slide-to-right': 'slideToRight 1.5s ease infinite',
    flash: 'flash 0.5s ease-in-out infinite alternate',
    jump: 'jump 6s infinite linear',
    grow: 'grow 1s infinite ease',
    'slide-and-merge': 'slideAndMerge 2.5s infinite alternate ease-in-out',
  },
  dropShadow: {
    'xs-strong': '0px 0px 3px rgba(0, 0, 0, 0.3)',
  },
  keyframes: {
    spin: {
      from: {
        transform: 'rotate(0deg)',
      },
      to: {
        transform: 'rotate(360deg)',
      },
    },
    spinExtreme: {
      from: {
        transform: 'rotate(0deg)',
      },
      to: {
        transform: 'rotate(6000deg)',
      },
    },
    grow: {
      '0%, 100%': {
        transform: 'scale(1)',
      },
      '50%': {
        transform: 'scale(1.015)',
      },
    },
    loadingIconSpin: {
      '0%': {
        transform: 'rotate(0deg)',
        'animation-timing-function': 'cubic-bezier(0.55, 0.055, 0.675, 0.19)',
      },
      '37%': {
        transform: 'rotate(900deg)',
        'animation-timing-function': 'cubic-bezier(0.215, 0.61, 0.355, 1)',
      },
      '75%, 100%': {
        transform: 'rotate(1800deg)',
      },
    },
    pulse: {
      '0%, 100%': {
        opacity: 1,
      },
      '50%': {
        opacity: 0.7,
      },
    },
    slideToRight: {
      '0%': {
        transform: 'translateX(-100%)',
      },
      '100%': {
        transform: 'translateX(100%)',
      },
    },
    flash: {
      from: {
        filter: 'hue-rotate(15deg)',
      },
      to: {
        filter: 'hue-rotate(0deg)',
      },
    },
    slideAndMerge: {
      '0%': {
        transform: 'translateX(-75%)',
        opacity: '1',
        filter: 'blur(0px) contrast(100%)',
      },
      '20%': {
        transform: 'translateX(-75%)',
        opacity: '1',
        filter: 'blur(0px) contrast(100%)',
      },
      '50%': {
        transform: 'translateX(0%)',
        filter: 'blur(24px) contrast(1.5)',
        opacity: '0.7',
      },
      '80%': {
        transform: 'translateX(75%)',
        opacity: '1',
        filter: 'blur(0px) contrast(100%)',
      },
      '100%': {
        transform: 'translateX(75%)',
        opacity: '1',
        filter: 'blur(0px) contrast(100%)',
      },
    },
  },
};
